﻿import AzureActiveDirectoryLoginProvider from 'Lib/Services/AzureActiveDirectoryLoginProvider';
import UserListLoginProvider from 'Lib/Services/UserListLoginProvider';
import type LoginProvider from 'Lib/LoginProvider';

export const LoginProvidersMap: { [key: string]: (config?: any) => LoginProvider } = {
    [AzureActiveDirectoryLoginProvider.staticKey]: (config?: any) => new AzureActiveDirectoryLoginProvider(config),
    [UserListLoginProvider.staticKey]: () => new UserListLoginProvider(),
};
